var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0026 3.1263C7.61783 3.1263 3.2526 7.32363 3.2526 12.5013C3.2526 17.679 7.61783 21.8763 13.0026 21.8763C18.3874 21.8763 22.7526 17.679 22.7526 12.5013C22.7526 7.32363 18.3874 3.1263 13.0026 3.1263ZM1.08594 12.5013C1.08594 6.17304 6.42121 1.04297 13.0026 1.04297C19.584 1.04297 24.9193 6.17304 24.9193 12.5013C24.9193 18.8296 19.584 23.9596 13.0026 23.9596C6.42121 23.9596 1.08594 18.8296 1.08594 12.5013ZM13.0026 7.29297C13.6009 7.29297 14.0859 7.75934 14.0859 8.33464V11.4596H17.3359C17.9342 11.4596 18.4193 11.926 18.4193 12.5013C18.4193 13.0766 17.9342 13.543 17.3359 13.543H14.0859V16.668C14.0859 17.2433 13.6009 17.7096 13.0026 17.7096C12.4043 17.7096 11.9193 17.2433 11.9193 16.668V13.543H8.66927C8.07096 13.543 7.58594 13.0766 7.58594 12.5013C7.58594 11.926 8.07096 11.4596 8.66927 11.4596H11.9193V8.33464C11.9193 7.75934 12.4043 7.29297 13.0026 7.29297Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.6af01e0b8837948828a0bd2d2f3a81b0.svg";
export { ForwardRef as ReactComponent };